import React from "react";
import ExternalLink from "./ExternalLink";
import { SVGWhatsApp } from "./SocialIcons";

export default function WhatsAppFAB() {
  if (
    process.env.GATSBY_SITE_DOMAIN !== "cif.com.ar" ||
    process.env.GATSBY_PATH_PREFIX !== "/"
  ) {
    return null;
  }

  return (
    <ExternalLink
      className="fixed bottom-0 right-0 w-20 h-20 z-20"
      href="https://api.whatsapp.com/send?phone=5491132492966"
      title="Chateá con Cif"
      onClick={() => {
        window.gtag &&
          window.gtag("event", "WhatsApp Message Click", {
            event_category: "Outbound Link",
            event_label: "Floating action button",
          });
      }}
    >
      <SVGWhatsApp />
    </ExternalLink>
  );
}
